import { memo } from 'react';
import { Button } from '@trinity/chat-components/components/presentation/Button/index.js';
import type { StaticButtonProps } from '@trinity/chat-components/components/presentation/Button/interfaces.js';
import { cx } from '@trinity/chat-components';
import styles from './style/HeaderButton.module.css';

type Props = {
  className?: string;
} & Omit<StaticButtonProps,
  'children' |
  'variant'>;

export const GroupTableHeaderButton = memo(({ className, ...btnProps }: Props) => {

  return (
    <Button
      {...btnProps}
      variant="brick"
      className={cx(styles.btn, className)} />
  );
});

export default GroupTableHeaderButton;